export const fiiAnalysisQueryKeys = {
  all: ['fii-analysis'] as const,
  detail: (ticker: string) => [...fiiAnalysisQueryKeys.all, ticker] as const,
}
